import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface Modelo {
  message: string;
  id: number;
  modelo: number;
  estado: number;
  fecha_registro: string;
  fecha_actualiza: string;
  usuario_creacion: string;
}

@Injectable({
  providedIn: 'root'
})
export class ModelosService {
  private apiUrl =  `${environment.apiUrl}/api/modelos`; 
  //private apiUrl = 'http://localhost:3000/api/modelos';

  constructor(private http: HttpClient) {}

  getModelos(): Observable<Modelo[]> {
    return this.http.get<Modelo[]>(this.apiUrl, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  getModeloById(id: number): Observable<Modelo> {
    return this.http.get<Modelo>(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  createModelo(datosModelo: any): Observable<Modelo> {
    return this.http.post<Modelo>(this.apiUrl, datosModelo, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  getModelosInactivos(): Observable<Modelo[]> {
    return this.http.get<Modelo[]>(`${this.apiUrl}/inactivos`, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  updateModelo(id: number, modelo: Partial<Modelo>): Observable<Modelo> {
    return this.http.put<Modelo>(`${this.apiUrl}/${id}`, modelo, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  deleteModelo(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  inactivarModelo(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/inactivar/${id}`, { estado: 0 }, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  activarModelo(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/activar/${id}`, { estado: 1 }, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: any) {
    console.error('Ocurrió un error:', error);
    const message = error.error?.message || 'Error en la solicitud.';
    return throwError(() => new Error(message));
  }
}
